// extracted by mini-css-extract-plugin
export var footer = "_ps-0";
export var inherit = "_ps-1";
export var input = "_ps-2";
export var modalContent = "_ps-3";
export var quillEditor = "_ps-4";
export var subtitle = "_ps-5";